$body = $("body");

var properties = {
    comments: [],
    currentURL: '',
    previousURL: '',
    savedURL: '',
    userLanguage: 'en',
    resetOnLoad: true,
    tutorial: false,
    popPages: ['contact', 'view', 'privacy-policy'],
    loadHash: '',
    disableStream: false,
    disableAutoFetch: false,
    loadHashID: '',
    feedbackURL: 'config/comments.php/feedback/',
    commentsURL: 'config/comments.php/comments/',
    likesURL: 'config/comments.php/likes/',
    firstLoad: false,
    firstExecute: false,
    allowedFiles: ['{{ package.srcFile }}'],
    initFile: '{{ package.srcFile }}',
    currentFile: ''
};

window.properties = properties;

var feedbackData = {
    data: {},
    comments: {},
    pages: {}
};

var startX,
  startY,
  endX,
  endY,
  position,
  parentOffset,
  mouseDragged = false;


$(document).on({
    ajaxStart: function() {
        $body.addClass("loading");
    },
    ajaxStop: function() {
        $body.removeClass("loading");
    },
    ajaxError: function() {
        $body.removeClass('loading');
    }
});

//Load
$(function() {

    $.ajaxSetup({
        // Disable caching of AJAX responses
        cache: false
    });

    function hashGrab() {
        var hash = window.location.hash.substring(1).split('/')[1];
        console.log(hash);
        loadPage(hash);
        // _gaq.push(['_trackPageview', hash]);
    }

    // Bind an event to window.onhashchange that, when the hash changes, gets the
    // hash and adds the class "selected" to any matching nav link.
    $(window).on('hashchange', function() {
        console.log('hash changes');
        if (properties.currentURL){
            hashGrab();
        }
    })
    $(window).on('pagesinit', function() {
      PDFViewerApplication.setTitle("{{ package.description }}");
    });
    $(window).on('updateviewarea', function() {
      PDFViewerApplication.setTitle("{{ package.description }}");
    });
    //initial Load
    $(window).load(function() {
        try {
            PDFViewerApplication.pdfViewer.spreadMode = 2;
            PDFViewerApplication.setTitle("{{ package.description }}");
        } catch(error) {
        }

        $('#outerContainer').removeClass('hidden');

        if (properties.resetOnLoad === true){
            properties.loadHash = window.location.hash.substring(1).split('/')[1];
            properties.loadHashID = window.location.hash.substring(2).split('/')[1];
            window.location.href = "#/";
        }


        //Form Validator
        webshims.setOptions('forms', {
            lazyCustomMessages: true,
            iVal: {
                handleBubble: 'hide', // defaults: true. true (bubble and focus first invalid element) | false (no focus and no bubble) | 'hide' (no bubble, but focus first invalid element)
                fx: 'fade', //defaults 'slide' or 'fade'
                sel: '.ws-validate', // simple selector for the form element, setting this to false, will remove this feature
                fieldWrapper: ':not(span, label, em, strong, b, i, mark, p)'
            }
        });
        webshims.polyfill('forms');
        webshim.activeLang(properties.userLanguage); //set locale to en


        hashGrab();
        feedback_handler.getFeedback();

    });

    //Global Events

    $( "#comment" ).click(function() {
      $('body').toggleClass('view-comment');
      return false;
    });


});

function loadPage(hash) {

    $('#content-root').removeClass('noswipe');

    if ($('#content-root').hasClass('swipe') == true && $('#content-root').hasClass('noswipe') == false){
        $('#outerContainer').removeClass('sidebarOpen');
    }

    if ($.inArray(properties.currentURL, properties.popPages) == -1){
        properties.previousURL = properties.currentURL;
    }

    if (hash == '' || hash == undefined) {
        hash = 'home';
    }

    home_handler.scrollTop();

    $("#content-root").load("templates/" + properties.userLanguage + "/" + hash + ".html", function(responseText, textStatus, req) {
        if (textStatus == "error") {
            properties.currentURL = '404';
            $("#content-root").load("templates/" + properties.userLanguage + "/404.html", function() {});
        } else {
            properties.currentURL = hash;
            var handler = hash.replace(/-/g, '_') + '_handler';
            if (window[handler]){
                var handler = window[handler];

                //Grab events
                handler.events();
            }


            $('.content-arrow').click(function(event) {

                if ( $('#outerContainer').hasClass('sidebarOpen') == true || ! $('#content-root').hasClass('swipe') ) {
                    home_handler.hideSidebar();
                } else {
                    home_handler.showSidebar();
                }
                return false;
            });

        }
    });

}
